import React from 'react';
import $ from 'jquery';
import { Collapse, DropdownItem, DropdownMenu, DropdownToggle, Nav, Navbar, NavLink, UncontrolledDropdown, UncontrolledTooltip } from 'reactstrap';
import './FullScreenMenu.css';

export class FullScreenMenu extends React.Component {
  wrapperStyle = {
    position: 'fixed',
    right: '0',
    zIndex: 10000
  }

  constructor(props) {
    super(props);
    this.toggleNavbar = this.toggleNavbar.bind(this);
    this.state = {
      collapsed: true
    };
  }

  toggleNavbar() {
    this.setState({
      collapsed: !this.state.collapsed
    });
  }

  setPageScrollTop(selector) {
    var newScrollTop = $(selector).offset().top;
    $('html, body').animate({
        scrollTop : newScrollTop
    }, 500);
  }

  render() {
    return (
      <div style={this.wrapperStyle}>
          <div id={'AmazonIcon'} className={"menu-item fa-2x px-2"} style={{ cursor: 'pointer' }}>
            <span className="fa-layers fa-fw mx-1" onClick={() => window.location = 'https://www.amazon.com/Shoji-iPhone-Case-Protects-Privacy/dp/B079RZBT48/'}>
              <i className="fas fa-circle" style={{ color: '#FF9900' }} data-fa-transform="grow-6"></i>
              <i className="fab fa-amazon" style={{ color: '#FFFFFF' }} data-fa-transform="shrink-3"></i>
            </span>
          </div>
          <UncontrolledTooltip placement="left" target="AmazonIcon">Shop now</UncontrolledTooltip>
          <div id={'FacebookIcon'} className={"menu-item fa-2x px-2"} style={{ cursor: 'pointer' }}>
            <span className="fa-layers fa-fw mx-1" onClick={() => window.location = 'https://www.facebook.com/Shojiphonecase/'}>
              <i className="fas fa-circle" style={{ color: '#3b5998' }} data-fa-transform="grow-6"></i>
              <i className="fab fa-facebook" style={{ color: '#FFFFFF' }} data-fa-transform="shrink-3"></i>
            </span>
          </div>
          <UncontrolledTooltip placement="left" target="FacebookIcon">Follow us on Facebook</UncontrolledTooltip>
          <div id={'HomeIcon'} className={"menu-item fa-2x px-2"} onClick={this.setPageScrollTop.bind(this, '#homeContainer')} style={{ cursor: 'pointer' }}>
            <span className="fa-layers fa-fw mx-1">
              <i className="fas fa-circle" style={{ color: '#000000' }} data-fa-transform="grow-6"></i>
              <i className="fas fa-home" style={{ color: '#FFFFFF' }} data-fa-transform="shrink-3"></i>
            </span>
          </div>
          <UncontrolledTooltip placement="left" target="HomeIcon">Jump to Home</UncontrolledTooltip>
          <div id={'VideoIcon'} className={"menu-item fa-2x px-2"} onClick={this.setPageScrollTop.bind(this, '#videoContainer')} style={{ cursor: 'pointer' }}>
            <span className="fa-layers fa-fw mx-1">
              <i className="fas fa-circle" style={{ color: '#000000' }} data-fa-transform="grow-6"></i>
              <i className="fas fa-video" style={{ color: '#FFFFFF' }} data-fa-transform="shrink-6"></i>
            </span>
          </div>
          <UncontrolledTooltip placement="left" target="VideoIcon">Jump to Video</UncontrolledTooltip>
          <div id={'ContactsIcon'} className={"menu-item fa-2x px-2"} onClick={this.setPageScrollTop.bind(this, '#whoAreWeContainer')} style={{ cursor: 'pointer' }}>
            <span className="fa-layers fa-fw mx-1">
              <i className="fas fa-circle" style={{ color: '#000000' }} data-fa-transform="grow-6"></i>
              <i className="fas fa-users" style={{ color: '#FFFFFF' }} data-fa-transform="shrink-6"></i>
            </span>
          </div>
          <UncontrolledTooltip placement="left" target="ContactsIcon">Who are we?</UncontrolledTooltip>
      </div>
    );
  }
}


// WEBPACK FOOTER //
// ./src/components/menus/FullScreenMenu.js